<template>
    <div class="page-class" v-if="isAccountLoaded">
        <nav-bar-logo
            class="history-nav"
            :userType="userType"
            :isBack="true"
            @clickBack="clickBack()">
        </nav-bar-logo>
        <div class="surprise-page surprise-main" ></div>
        <div>
            <div v-if="isDisabled">
                 <img class="surprise-btn" src="@/assets/image/Surprise/img-btn-surprise-inactive.png" alt="">
            </div>
            <div v-else>
                <img class="surprise-btn m-auto" src="@/assets/image/Surprise/img-btn-surprise-active.png" alt="" @click="clickDraw()">
            </div>
        </div>
        <modal-master :controller="modalController" :theme="userType"></modal-master>
    </div>
</template>
<script>
//helper
import Account from '@/helper/AccountHelper.js';
import Util from '@/helper/Utility.js';
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
//component
import NavBarLogo from "@/components/Layout/NavBar/NavBarLogo.vue";
// import SurpriseHeader from "../component/SurpriseHeader.vue";
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { AlertModalController } from "@/components/Modal/Controller/AlertModalController.js";
import { ConfirmModalController } from "@/components/Modal/Controller/ConfirmModalController.js";
import { LoadingModalController } from "@/components/Modal/Controller/LoadingModalController.js";
//service
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
import BlobService from '@/core/BlobService/service/BlobService.js';
import { CampaignConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel.js";
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign.js';
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";

export default {
    name: 'SurpriseMain',
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin],
    components: {
        ModalMaster,
        NavBarLogo,
        // SurpriseHeader,
    },
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    data: function() {
        return {
            campaignId: null,
            campaignConfig: null,
            campaign: null,
            //modal
            modalController: new ModalController(),
            alertModal: new AlertModalController(),
            confirmModal: new ConfirmModalController(),
            loadingModal: new LoadingModalController(),
            pointUser: null,
            textBtn: '',
            isDisabled: false
        };
    },
    created: function() {

        //modal
        this.modalController.setAlertModal(this.alertModal);
        this.modalController.setConfirmModal(this.confirmModal);
        this.modalController.setLoadingModal(this.loadingModal)

        //error
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.alertModal);

        this.getBlobConfig();
        this.getUserPoint();
    },
    methods: {
        getBlobConfig: function(){
            BlobService.getSurpriseConfig()
            .then(res => {
                console.log('camp', res.data);
                this.campaignId = res.data.id;
                this.getCampaignDetail();
                //console.log('camp', this.campaignId);
            }).catch(err => {
                console.log(err);
            });
        },
        getCampaignDetail: function () {
            this.loadingModal.show();

            var token = Account.getToken();
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(this.campaignId)
                .create();

            BzbsCampaign.apiGetCampaignDetail(token, this.campaignConfig)
                .then(res => {
                    this.campaign = res;
                    console.log('camp', this.campaign);
                    this.loadingModal.hide();
                    this.handleBtn();

                }).catch(err => {
                    this.loadingModal.hide();
                    this.errorResponse(err, this.errorHandler);
                });
        },
        openConfirmModal: function(msg){
            // console.log('point', this.point);
            // console.log('cpoint', this.campaign.pointPerUnit);

            if(this.point < this.campaign.pointPerUnit){
                this.confirmModal
                    .clearText()
                    .setTag('draw-confirm')
                    .setTitle(this.lbl.surprise.confirm.title)
                    .setMsg(msg)
                    .setMsgError(this.lbl.surprise.confirm.point_not_enough)
                    .setBtnOk(this.lbl.surprise.confirm.btn_confirm)
                    .setBtnCancel(this.lbl.surprise.confirm.btn_cancel)
                    .show()
            }else{
                this.confirmModal
                    .clearText()
                    .setTag('draw-confirm-success')
                    .setTitle(this.lbl.surprise.confirm.title)
                    .setMsg(msg)
                    .setBtnOk(this.lbl.surprise.confirm.btn_confirm)
                    .setBtnCancel(this.lbl.surprise.confirm.btn_cancel)
                    .show()
            }

            this.confirmModal.onClickOk((data) =>{
                if(data.tag == 'draw-confirm-success'){
                    this.$router.push('/surprisebox/open');
                }
            });
        },
        //event
        clickDraw: function(){
            let colorCode = '#24924c';
            switch(this.userType){
                case 'farmer':
                    colorCode = '#24924c';
                    break;
                case 'subdist':
                    colorCode = '#24924c';
                    break;
                case 'dist':
                    colorCode = '#1eaba6';
                    break;
                case 'sale':
                    colorCode = '#0d7bab';
                    break;
            }

            let point = `<span style='color: ${colorCode}'>${this.campaign.pointPerUnit} ${this.lbl.surprise.confirm.msg_point}</span>`;
            let msg = Util.stringFormat(this.lbl.surprise.confirm.msg, point);

            this.openConfirmModal(msg);

        },
        getUserPoint: function () {
            // this.pointUser = Account.getCachePoint();
            var token = this.getToken();
            BzbsProfile.getPoint(token)
                .then(res => {
                    this.pointUser = res.data.points;
                }).catch(err => {
                    this.errorResponse(err, this.errorHandler);
                });
        },
        handleBtn: function() {
            //Check interval.
            var conditionAlert = this.campaign.conditionAlert;
            if (conditionAlert == 'ขออภัย คุณได้กดรับ Campaign นี้ไปแล้ว กรุณารอกดรับใหม่อีกครั้งภายหลัง') {
                this.textBtn = this.lbl.surprise.btn_diabled.interval;
                this.isDisabled = true;
                return;
            }
            //Check expire date.
            if (this.campaign.currentDate > this.campaign.expireDate) {
                this.textBtn = this.lbl.surprise.btn_diabled.expire_date;
                this.isDisabled = true;
                return;
            }
            //Check full quota.
            if (conditionAlert == 'ขออภัย สิทธิพิเศษในการใช้สินค้า/บริการนี้ มีผู้ใช้สิทธิ์เต็มจำนวนแล้ว') {
                this.textBtn = this.lbl.surprise.btn_diabled.full_quota;
                this.isDisabled = true;
                return;
            }
            //Check point not enough.
            if (this.pointUser < this.campaign.pointPerUnit) {
                this.textBtn = this.lbl.surprise.btn_diabled.point_not_enough;
                this.isDisabled = true;
                return;
            }
            return (this.textBtn = this.lbl.surprise.btn_draw,this.isDisabled = false);
        },
        clickBack: function(){
            this.$router.push('/');
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/common.scss";
@import "../style/SurpriseBox.scss";
</style>
